import localizationService from "../services/localization-service.js";
import { useSelector } from "react-redux";

const UserMenu = ({ isOpen, onLanguageChange, onTimeZoneChange, currentTimeZone, timeZones, onLogout }) => {
  const selectedlang = useSelector((state) => state.account.lang);

  if (!isOpen) return null;

  return (
    <div className="absolute right-0 mt-2 w-[200px] bg-white border rounded-lg shadow-lg z-10 space-y-3">
      {/* Language Selector */}
      <div className="flex items-center space-x-2 text-sm px-4 py-3 hover:bg-[#f4f6ea]">
        <i className="fal fa-globe mr-3 text-[#9aa82d] text-lg"></i>
        <div className="flex items-center space-x-2 text-sm mx-0">
          <button
            type="button"
            onClick={() => onLanguageChange("en-CA")}
            className={`${selectedlang === "en-CA"
              ? "text-[#9aa82d] font-semibold"
              : "text-gray-400 hover:text-gray-600"
              }`}
          >
            EN
          </button>

          <span className="text-gray-300">|</span>

          <button
            type="button"
            onClick={() => onLanguageChange("fr-CA")}
            className={`${selectedlang === "fr-CA"
              ? "text-[#9aa82d] font-semibold"
              : "text-gray-400 hover:text-gray-600"
              }`}
          >
            FR
          </button>
        </div>
      </div>

      <hr className="mx-auto my-0" />

      {/* Time Zone Button */}
      <button
        onClick={onTimeZoneChange}
        className="flex items-center w-full px-4 py-3 text-sm rounded-md text-[#9aa82d] bg-white hover:bg-[#f5f7eb] my-0 font-medium hover:!bg-[#f4f6ea]"
      >
        <i className="fal fa-clock mr-3 text-lg"></i>
        {currentTimeZone
          ? timeZones.find((x) => x.id == currentTimeZone).name
          : localizationService.getLocalizationValue(
            "setTimeZone",
            selectedlang,
          )}
      </button>

      <hr className="mx-auto my-0" />

      {/* Logout Button */}
      <button
        onClick={() => onLogout()}
        className="flex items-center w-full px-4 py-3 text-sm rounded-md text-[#9aa82d] bg-white hover:bg-[#f5f7eb] my-0 font-medium hover:!bg-[#f4f6ea]"
      >
        <i className="fal fa-sign-out mr-3 text-lg"></i>
        {localizationService.getLocalizationValue(
          "sideMenuLogoutTitle",
          selectedlang,
        )}
      </button>
    </div>
  );
};

export default UserMenu;
